import { Box, Icon } from '@nimbus-ds/components';
import { TiendanubeIcon } from '@nimbus-ds/icons';
import { Menu } from '@nimbus-ds/patterns';
import { Logo, LogoProps } from 'App/components';
import { useAgentChatPanelContext } from 'App/components/AgentChatPanelContext';
import { useDesktopMenuContext } from 'App/components/Menu/DesktopMenuProvider';
import { NEW_ADMIN_ONBOARDING_COLLAPSE_MENU_202511 } from 'App/featuresFlags';
import { useGetTags } from 'domains/Auth/hooks';
import { MenuExpandToggle } from './components';

interface MainMenuDesktopHeaderProps {
  headerLogo: LogoProps['src'];
  headerLogoColor: string;
  expanded: boolean;
}

export function MainMenuDesktopHeader({
  headerLogo,
  headerLogoColor,
  expanded,
}: Readonly<MainMenuDesktopHeaderProps>) {
  const { toggleMenuExpanded } = useDesktopMenuContext();
  const { isOpen: isAgentChatOpen } = useAgentChatPanelContext();
  const tags = useGetTags();
  const hasCollapseMenuTag = tags.includes(
    NEW_ADMIN_ONBOARDING_COLLAPSE_MENU_202511,
  );

  if (!hasCollapseMenuTag) {
    return (
      <div className="stratus--menu-header">
        <Menu.Header>
          {expanded ? (
            <Box display="flex" py="2" width="100%">
              <Logo src={headerLogo} color={headerLogoColor} />
            </Box>
          ) : (
            <Box display="flex" py="2" width="100%" justifyContent="center">
              <Icon
                source={<TiendanubeIcon size={24} />}
                color="primary-interactive"
              />
            </Box>
          )}
        </Menu.Header>
      </div>
    );
  }

  return (
    <div className="stratus--menu-header">
      <Menu.Header>
        {expanded ? (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            pt="1"
            width="100%"
          >
            <Logo src={headerLogo} color={headerLogoColor} />
            <MenuExpandToggle
              expanded={expanded}
              onToggle={toggleMenuExpanded}
            />
          </Box>
        ) : isAgentChatOpen ? (
          <Box display="flex" justifyContent="center" py="2" width="100%">
            <Icon
              source={<TiendanubeIcon size={24} />}
              color="primary-interactive"
            />
          </Box>
        ) : (
          <MenuExpandToggle expanded={expanded} onToggle={toggleMenuExpanded} />
        )}
      </Menu.Header>
    </div>
  );
}
